import React, { useEffect, useState, useRef, useCallback, memo } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import InModalSpq from './InModalSpq';
import './css/popupSpqModal.scss';
import { useInteractiveSPQ } from '../../../Queries/QueryHooks/interactiveSPQ.hook';

let timeoutHandler = null;
const PopupSpq = ({ id, type }) => {
  const [modalShow, setModalShow] = useState(false);
  const [spqData, setSpqData] = useState([]);
  const spqTotalDataList = useRef([]);
  const spqListlength = useRef(0);
  const count = useRef(0);

  console.log('SPQDATA', spqData);

  const handleOpen = () => {
    setModalShow(true);
  };
  const handleClose = useCallback(() => {
    console.log('interactiveSPQ ###', `count${count.current}`, spqListlength.current);
    if (count.current < spqListlength.current - 1) {
      setModalShow(false);
      clearTimeout(timeoutHandler);
      // count.current == spqListlength.current ? count.current : count.current + 1;
      count.current = count.current + 1;
      interactiveSpqHandler(spqTotalDataList.current);
    } else {
      setModalShow(false);
      clearTimeout(timeoutHandler);
    }
  }, [modalShow]);

  const nextIncompletedSurveySelector = () => {
    if (count.current < spqListlength.current - 1) {
      if (timeoutHandler) {
        clearTimeout(timeoutHandler);
      }
      count.current = count.current + 1;
      interactiveSpqHandler(spqTotalDataList.current);
    }
  };
  const interactiveSpqHandler = (data) => {
    console.log('count.current', data);
    let surveyStatus = data[count.current]?.user_survey_status;
    // console.log('surveyStatus', surveyStatus);
    if (surveyStatus == 0) {
      timeoutHandler = setTimeout(
        () => {
          setSpqData(data[count.current]);
          handleOpen();
        },
        typeof data[count.current]?.duration == 'string'
          ? parseInt(data[count.current]?.duration) * 1000
          : data[count.current]?.duration * 1000
      );
    } else {
      console.log('LOGGING_NEXT');
      nextIncompletedSurveySelector();
    }
  };
  const onSuccess = (data) => {
    console.log('interactiveSPQ', data);
    if (data && data?.length > 0) {
      spqListlength.current = data?.length;
      spqTotalDataList.current = data;
      interactiveSpqHandler(data);
    }
  };
  const onError = () => {};
  const { data: spqVideoList, isLoading } = useInteractiveSPQ(type, id, onSuccess, onError);
  console.log('interactiveSPQ ref', spqVideoList);
  return (
    <>
      {!isLoading && (
        <Modal
          className="centerModal spqModal"
          size="md"
          centered
          show={modalShow}
          onHide={() => setModalShow(false)}
        >
          <Modal.Header>
            <Modal.Title className="fs-4 text-black fw-semibold d-flex justify-content-between align-items-center w-100">
              <h4 className="fs-3 fw-medium text-black">
                Answer the below {spqData.category} to proceed
              </h4>
              <div className="spqModalBtns d-flex gap-2 gap-md-3">
                {spqData.skip == 1 && spqData.category != 'quiz' && (
                  <Button
                    className="text-black bg-light fs-4 fw-medium rounded-3 border-0"
                    onClick={handleClose}
                  >
                    X
                  </Button>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ 'overflow-y': 'auto' }}>
            <InModalSpq id={id} skipBtn={false} handleClose={handleClose} data={spqData} />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default memo(PopupSpq);
